module.exports = __webpack_public_path__ + "img/262-united-kingdom.5bb25e78.svg";